<template>
    <rkm-modal
        :loading="loading"
        :title="`${id ? 'Edição' : 'Cadastro'} de plantão`"
        large
        ref="Modal"
        no-close-on-backdrop
        no-close-on-esc
    >
        <Form
            :id="id"
            @save="handleExit"
            ref="Form"
        />

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.save(enums.status.CONFIRMADO)"
                color="primary"
            >
                Salvar e confirmar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.save()"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Enums.
import status from '@/enums/pronto-atendimento/plantao/status'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    data: () => ({
        enums: {status},
        id: null,
    }),
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    methods: {
        open(id) {

            this.id = id

            this.$refs.Modal.show()
        },
        handleExit({ plantao, updated }) {

            this.$emit('save', plantao, updated)

            if (updated) {

                this.$refs.Modal.hide()
            }
        },
    }
}
</script>
